module.exports = __webpack_public_path__ + "img/am10.6c58e50b.jpg";